import { render, staticRenderFns } from "./UberTrips.vue?vue&type=template&id=626a9120&scoped=true&"
import script from "./UberTrips.vue?vue&type=script&lang=js&"
export * from "./UberTrips.vue?vue&type=script&lang=js&"
import style0 from "./UberTrips.vue?vue&type=style&index=0&id=626a9120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a9120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VNavigationDrawer,VTab,VTabItem,VTabs,VTabsItems})
